import type { RowAction } from '@/components/ui/data-table/types';
import type { Work } from '@certhon/models';

export { adaptActionsForPanel } from '@/utils/adaptActionsForPanel';

/**
 * Get actions for a work - works for both row actions (table) and panel actions.
 * Note: PDF report action is handled separately in the details panel via TicketReportContext.
 */
export function getWorkActions(): RowAction<Work>[] {
  const actions: RowAction<Work>[] = [];

  // Add more work-specific actions here as needed

  return actions;
}
